/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';

//compoennts
import { Cpds } from '@Cpds.Ui';
import { CpdsGridPlaceholderStyleTag, CpdsGridPlaceholderCard } from './styles/cpds-grid-placeholder-style';

//hooks and helpers
import { useWindowDimensions } from 'src/components/common/useWindowDimentions';
import { themeStyleClass } from '../utils/cpds-utils';
import { checkValue } from 'src/components/common/helper';

//typings
import { CpdsGridPlaceholderProps } from './typings';
import { CpdsGridStyleProps } from '../cpds-grid/typings';

const CpdsGridPlaceholder: React.FC<CpdsGridPlaceholderProps> = (props) => {
  const { domRef, exClasses, styleOverrides, themeTypography, loadingCards, id } = props;
  const className = themeStyleClass('cpds-grid-placeholder', themeTypography, exClasses);

  const { width: windowWidth } = useWindowDimensions();
  const [noOfCards, setNoOfCards] = useState(1);

  const templateColumns = () => {
    const xl = checkValue(loadingCards?.xl) ? loadingCards?.xl : 3;
    const lg = checkValue(loadingCards?.lg) ? loadingCards?.lg : 3;
    const md = checkValue(loadingCards?.md) ? loadingCards?.md : 2;

    if (windowWidth > 1679) return `repeat(${xl}, 1fr)`;
    if (windowWidth > 1279) return `repeat(${lg}, 1fr)`;
    if (windowWidth > 767) return `repeat(${md}, 1fr)`;
    return '1fr';
  };

  const dealsCardContainerProps: CpdsGridStyleProps = {
    gridTemplateColumns: templateColumns(),
    columnGap: '24px',
    rowGap: '24px',
    mediaQueries: {
      '1279px': {
        columnGap: '16px',
        rowGap: '16px',
      },
      '767px': {
        columnGap: '12px',
        rowGap: '12px',
      },
    },
  };

  useEffect(() => {
    let cards = 1;
    if (windowWidth > 1679) {
      cards = checkValue(loadingCards?.xl) ? loadingCards?.xl : 3;
    } else if (windowWidth > 1279) {
      cards = checkValue(loadingCards?.lg) ? loadingCards?.lg : 3;
    } else if (windowWidth > 767) {
      cards = checkValue(loadingCards?.md) ? loadingCards?.md : 2;
    } else {
      cards = 1;
    }
    setNoOfCards(cards);
  }, [windowWidth]);

  return (
    <CpdsGridPlaceholderStyleTag className={className} ref={domRef} styleOverrides={styleOverrides}>
      <Cpds.GridContainer gridStyleProps={dealsCardContainerProps}>
        {[...Array(noOfCards)].map(() => (
          <div key={`${id}-placeholder-card-${1}`}>
            <CpdsGridPlaceholderCard />
          </div>
        ))}
      </Cpds.GridContainer>
    </CpdsGridPlaceholderStyleTag>
  );
};

export default CpdsGridPlaceholder;
